import {
  createActionTypeManagementUseCase,
  deleteActionTypeManagementUseCase,
  getActionTypeManagementUseCase,
  updateActionTypeManagementUseCase,
} from '@/di';
import type {
  ActionTypeEntity,
  CreateActionTypePayload,
  UpdateActionTypePayload,
} from '@/domains/actionType/actionType.entity';
import { useEffect, useState } from 'react';

export const useActionTypeData = () => {
  const [actionTypes, setActionTypes] = useState<ActionTypeEntity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadActionTypes = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getActionTypeManagementUseCase().execute();
      setActionTypes(data);
    } catch (err) {
      setError('Error al cargar los tipos de acciones');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const createActionType = async (payload: CreateActionTypePayload) => {
    try {
      setError(null);
      await createActionTypeManagementUseCase().execute(payload);
      await loadActionTypes();
      return true;
    } catch (err) {
      setError('Error al crear el tipo de acción');
      console.error(err);
      return false;
    }
  };

  const updateActionType = async (
    cod_tipo_accion: number,
    payload: UpdateActionTypePayload,
  ) => {
    try {
      setError(null);
      await updateActionTypeManagementUseCase().execute(
        cod_tipo_accion,
        payload,
      );
      await loadActionTypes();
      return true;
    } catch (err) {
      setError('Error al actualizar el tipo de acción');
      console.error(err);
      return false;
    }
  };

  const deleteActionType = async (cod_tipo_accion: number) => {
    try {
      setError(null);
      await deleteActionTypeManagementUseCase().execute(cod_tipo_accion);
      await loadActionTypes();
      return true;
    } catch (err) {
      setError('Error al eliminar el tipo de acción');
      console.error(err);
      return false;
    }
  };

  useEffect(() => {
    loadActionTypes();
  }, []);

  return {
    actionTypes,
    loading,
    error,
    loadActionTypes,
    createActionType,
    updateActionType,
    deleteActionType,
  };
};
